<script>
import ProductBox from '@/components/products/ProductBox.vue'
import ShowFilters from '@/components/shop/ShowFilters.vue'

export default {
  name: 'ShopList',
  components: { ShowFilters, ProductBox },
  props: {
    products: {
      type: Object,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <section class="py-8 antialiased dark:bg-gray-900 md:py-12 flex-1">
    <div class="mx-auto max-w-screen-xl px-4 2xl:px-0">
      <div class="mt-5 mb-20">
        <h1 class="text-primary-700 text-2xl font-sigmar tracking-wider lg:text-6xl font-extrabold">
          Toutes nos bières <br>
        </h1>
        <span class="text-primary-700 text-xl lg:text-3xl font-extrabold font-sigmar tracking-wider ml-20 lg:ml-96">et bien plus...</span>
      </div>
      <show-filters />
      <div class="mb-4 grid gap-4 sm:grid-cols-2 md:mb-8 lg:grid-cols-3 xl:grid-cols-4">
        <product-box v-for="(product, index) in products" :key="index" :product="product" />
      </div>
    </div>
  </section>
</template>

<style scoped>

</style>